export const TERM_PAGE_BASE_PATH = 'terms';

export const TERM_PAGE_SUB_PATHS = [
    `/${TERM_PAGE_BASE_PATH}/`,
    `/${TERM_PAGE_BASE_PATH}/terms-of-use/`,
    `/${TERM_PAGE_BASE_PATH}/privacy/`,
    `/${TERM_PAGE_BASE_PATH}/affiliate/`,
    `/${TERM_PAGE_BASE_PATH}/instructor/`,
    `/${TERM_PAGE_BASE_PATH}/promotions/`,
    `/${TERM_PAGE_BASE_PATH}/genai-instructor-policy/`,
    `/${TERM_PAGE_BASE_PATH}/ub/`,
    `/${TERM_PAGE_BASE_PATH}/msa-india/`,
    `/${TERM_PAGE_BASE_PATH}/corpu-terms/`,
    `/${TERM_PAGE_BASE_PATH}/upro-terms/`,
    `/${TERM_PAGE_BASE_PATH}/launch-services/`,
    `/${TERM_PAGE_BASE_PATH}/ub-privacy/`,
    `/${TERM_PAGE_BASE_PATH}/ub-subprocessor/`,
    `/${TERM_PAGE_BASE_PATH}/dpa/`,
    `/${TERM_PAGE_BASE_PATH}/mnda/`,
    `/${TERM_PAGE_BASE_PATH}/msa-vendor/`,
    `/${TERM_PAGE_BASE_PATH}/saa/`,
    `/${TERM_PAGE_BASE_PATH}/po/`,
    `/${TERM_PAGE_BASE_PATH}/copyright/`,
    `/${TERM_PAGE_BASE_PATH}/api/`,
    `/${TERM_PAGE_BASE_PATH}/beta/`,
    `/${TERM_PAGE_BASE_PATH}/events/`,
    `/${TERM_PAGE_BASE_PATH}/digital-services-act/`,
    `/${TERM_PAGE_BASE_PATH}/data-processing-agreement/`,
    `/${TERM_PAGE_BASE_PATH}/instructor-partner-program/`,
    `/${TERM_PAGE_BASE_PATH}/responsible-ai-principles/`,
    `/${TERM_PAGE_BASE_PATH}/udemy-ireland-gender-pay-gap/`,
    `/${TERM_PAGE_BASE_PATH}/pa-terms/`,
    `/${TERM_PAGE_BASE_PATH}/emtrain-terms/`,
    `/${TERM_PAGE_BASE_PATH}/brazil/`,
    `/${TERM_PAGE_BASE_PATH}/subscription-bonus/`,
    `/${TERM_PAGE_BASE_PATH}/premium-support/`,
    `/${TERM_PAGE_BASE_PATH}/learn-with-google/`,
    `/${TERM_PAGE_BASE_PATH}/ai-connector/`,
];
